import React from 'react';
import Icon from '../../../components/AppIcon';

const TimeframeFilter = ({ activeTimeframe, onTimeframeChange }) => {
  const timeframes = [
    { id: 'daily', label: 'Today', icon: 'Calendar' },
    { id: 'weekly', label: 'This Week', icon: 'CalendarDays' },
    { id: 'monthly', label: 'This Month', icon: 'CalendarRange' },
    { id: 'alltime', label: 'All Time', icon: 'Infinity' }
  ];

  return (
    <div className="flex flex-wrap gap-2">
      {timeframes?.map((timeframe) => (
        <button
          key={timeframe?.id}
          onClick={() => onTimeframeChange(timeframe?.id)}
          className={`
            flex items-center gap-2 px-4 py-2 rounded-lg border transition-smooth
            ${activeTimeframe === timeframe?.id
              ? 'bg-accent text-accent-foreground border-accent shadow-md'
              : 'bg-card text-foreground border-border hover:border-accent/50 hover:shadow-sm'
            }
          `}
        >
          <Icon 
            name={timeframe?.icon} 
            size={16} 
            color={activeTimeframe === timeframe?.id ? 'currentColor' : 'var(--color-muted-foreground)'} 
          />
          <span className="text-sm font-medium">{timeframe?.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TimeframeFilter;